export default{
  accountInfo: (state) => state.accountInfo,
  logged: (state) => state.logged,
  pricings: (state) => state.pricings,
  s3Credentials: (state) => state.s3Credentials,
  s3Bucket: (state) => state.bucket,
  activeProjectNumber: (state) => state.activeProjectNumber,
  inactiveProjectNumber: (state) => state.inactiveProjectNumber,
  firstProject: (state) => state.firstProject,
  lastProject: (state) => state.lastProject
}



// WEBPACK FOOTER //
// ./src/components/account/store/getters.js